import { connect } from 'react-redux';

import { removeCreativeAssociation } from '../creative-assets/actions';
import CreativesPreview from './CreativesPreview';

const mapStateToProps = (
  {
    creativeAssets: { creativesById },
    campaignEditor: { campaignLineCreativesByLineId, campaignLinesById },
  },
  { campaignLineId },
) => ({
  creativesById,
  campaignLineCreatives: campaignLineCreativesByLineId[campaignLineId] || [],
  productId: campaignLinesById[campaignLineId].product.id,
});

const mapDispatchToProps = {
  removeCreativeAssociation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreativesPreview);
